import React from 'react';

// Component for displaying calculation history
const CalculationHistory = ({ history, currencySymbols }) => {
  if (!history || history.length === 0) {
    return null;
  }

  // Format date for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };

  // Format currency values
  const formatCurrency = (value) => {
    return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className="calculation-history">
      <h3>Calculation History</h3>
      <div className="history-list">
        {history.map((item, index) => {
          const currencySymbol = currencySymbols[item.currency] || '$';
          
          return (
            <div key={index} className="history-item">
              <span className="date">{formatDate(item.date)}</span>
              <span className="arrow">→</span>
              <span className="amount">
                {currencySymbol}{formatCurrency(item.zakatDue)} {item.currency}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CalculationHistory;